import Image from 'next/image';
import { cn } from '@/lib/utils/cn';

type PartnerLogo = { src: string; alt: string; width: number; height: number };

type Props = {
  title: string;
  subtitle?: string;
  // Logo partenaire affiché à côté du picto (« Mindexia × partenaire »).
  partnerLogo?: PartnerLogo | null;
};

const TILE = 'flex h-12 items-center justify-center rounded-md bg-purple-50 sm:h-14';

export function AuthBrandHeader({ title, subtitle, partnerLogo }: Props) {
  // La rangée co-marquée (deux tuiles) est plus lourde que le picto seul : le
  // titre prend plus d'air au-dessus et en dessous.
  const coBranded = Boolean(partnerLogo);
  return (
    <div className="flex flex-col items-center">
      <div
        className={cn(
          'flex items-center gap-2.5 sm:gap-3',
          coBranded ? 'mb-5 sm:mb-6' : 'mb-2.5 sm:mb-3',
        )}
      >
        <div className={cn(TILE, 'w-12 sm:w-14')}>
          <Image
            src="/brand/picto.png"
            alt="Mindexia"
            width={44}
            height={44}
            priority
            className="h-9 w-9 object-contain sm:h-11 sm:w-11"
          />
        </div>
        {partnerLogo ? (
          <>
            <span aria-hidden className="text-fg-4 text-base font-medium">
              ×
            </span>
            <div className={cn(TILE, 'px-3 sm:px-3.5')}>
              <Image
                src={partnerLogo.src}
                alt={partnerLogo.alt}
                width={partnerLogo.width}
                height={partnerLogo.height}
                priority
                className="h-8 w-auto object-contain sm:h-10"
              />
            </div>
          </>
        ) : null}
      </div>
      <h1 className="text-fg-1 text-center text-[24px] leading-[1.15] font-bold tracking-tight text-balance sm:text-[32px] sm:leading-[1.1]">
        {title}
      </h1>
      {subtitle ? (
        <p
          className={cn(
            'text-fg-3 mx-auto max-w-[360px] text-center text-[13px] text-pretty sm:text-sm',
            coBranded ? 'mt-3 sm:mt-4' : 'mt-1.5 sm:mt-2',
          )}
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
